/** Sets where links open: guides in the same tab (also inside the app), everything else linked from articles in a new one */
export function setLinkTargets() {
    links('.guide a').forEach(link => {
        if (!link.href.includes('/guides')) return
        link.target = '_self'
        link.classList.add('inheritParameters')
    })

    links('.article-content a:not(.btn)').forEach(link => {
        if (link.href && !link.href.includes('/guides')) link.target = '_blank'
    })
    links(".article-content:not(.guide) a[href^='#']").forEach(link => link.target = '_self')
}

/** Returns the HTML links matching the selector, skipping SVG `<a>` elements, whose `href` isn't a string */
function links(selector: string) {
    return [...document.querySelectorAll(selector)].filter(link => link instanceof HTMLAnchorElement)
}
